// import React, { useState } from "react";
// import axios from "axios";
// import { useRouter } from "next/navigation";

// /**
//  * A custom hook that provides functionality to make PUT requests.
//  * It maintains the state of the request including data, loading, and error states.
//  * If authentication is required, it appends the Bearer token from local storage to the Authorization header.
//  * Redirects to the home page if authentication fails.
//  * 
//  * @return {Object} An object containing the data, setData, error, setError, loading, setLoading, and PostData function.
//  */
// const usePutApi = () => {
//   const [data, setData] = useState(null);
//   const [loading, setLoading] = useState(false);
//   const [error, setError] = useState(null);
//   const router =useRouter();

//   /**
//    * Makes a PUT request to the given url. If auth is true, then it appends the Bearer token from local storage to the Authorization header.
//    * @param {string} url - The url of the API endpoint
//    * @param {boolean} auth - Whether to append the token to the Authorization header
//    * @param {Object} body - The data to be sent with the request
//    * @returns {Promise<void>}
//    */
//   const PostData = (url, auth, body) => {
//     setLoading(true);
//     if( auth && !localStorage.getItem("ACCESS")){
//       router.replace('/')
//       return
//     }
    
//     console.log(body)
//     let token = `Bearer ${localStorage.getItem("ACCESS")}`;

//     axios
//       .put(
//         url,
//         body,
//         {
//           headers: {
//             Authorization: auth ? token : "",
//           },
//         }
//       )
//       .then((result) => setData(result.data))
//       .catch((err)=>{
//             console.log(err)
//             setError(err.response.data)
//       })
//       .finally(()=>{
//         setLoading(false)
//       })
//   };

//   return {data,setData,error,setError,loading,setLoading,PostData}
// };

// export default usePutApi;


import { useState } from "react";
import { toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";
function useApiPut() {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const Putdata = (url, auth, payload) => {
        let token = `Bearer ${localStorage.getItem('ACCESS')}`

        const headerData ={
                // "Content-Type":payload instanceof FormData ? "multipart/form-data" : "",
                "Authorization": auth ? token : "",
        }

        if(! (payload instanceof FormData)){
            headerData["Content-Type"] = "application/json"
        }


        // console.log(payload instanceof FormData);
        setLoading(true);
        setError(null);
        fetch(url, {
            method: "PUT",
            headers: headerData,
            body: payload instanceof FormData ? payload : JSON.stringify(payload)
        })
            .then((r) => r.json().then((data) => ({ status: r.status, body: data })))
            .then((result) => {
                //console.logresult.status)
                

                if (result.status === 200) {
                    setData(result);
                }
                if (result.status === 401 || result.status === 403 || result.status ===404) {
                   setError(result)
                }
                if (result.status === 400 ) {
                    //console.log'comming into the rro')
                    setError(result)
                }
                if (result.status === 405) {

                }

                if (result.status === 500) {

                }
            })
            .catch((err) => {
                console.error(err);
                toast.warning('Something went wrong, Try again', {
                    position: "top-center",
                  });
                  toast.clearWaitingQueue();
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return { data, loading, error, Putdata, setData, setLoading, setError };
}

export default useApiPut;
